module.exports = __webpack_public_path__ + "img/swiper8.c7e9751a.png";